export default function optimisticId(): string {
  return `@${Math.random().toString(36)}`;
}
